import * as Caml_obj from "bs-platform/lib/es6/caml_obj.js";
var compare = Caml_obj.caml_compare;
export { compare };
/* No side effect */